import React from 'react';

export default function DisclaimerStrip() {
  return (
    <div style={{
      background: 'rgba(9,20,36,0.98)',
      borderBottom: '1px solid rgba(201,168,76,0.18)',
      padding: '7px 20px',
      textAlign: 'center',
      fontSize: '0.7rem',
      color: 'rgba(168,207,224,0.55)',
      letterSpacing: '0.03em',
      lineHeight: 1.5,
      position: 'relative',
      zIndex: 100,
    }}>
      18+ · Session points have no monetary value · No purchases · No withdrawals · No prizes ·{' '}
      <strong style={{ color: 'rgba(168,207,224,0.75)' }}>Social North Hub</strong> is an entertainment platform only
    </div>
  );
}
